import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Menu, MenuInfo } from 'src/app/enum/menu.enum';
import { Perfil } from 'src/app/model/perfil';
import { PerfilService } from 'src/app/service/perfil.service';

@Component({
  selector: 'app-perfil-form',
  templateUrl: './perfil-form.component.html',
  styleUrls: ['./perfil.component.scss'],
})
export class PerfilFormComponent implements OnInit {

  formulario: FormGroup;
  mensagemErros: String[] = [];
  permissoes: string[] = [];
  nomePermissoes: string[] = [];
  carregando = false;

  constructor(
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    private perfilService: PerfilService,
    private router: Router,
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.montarFormulario();
    this.getPermissoes();

    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.carregar(+id);
    }
  }

  togglePermissao(permissao: string) {
    const control = this.formulario.get('permissoes');
    const permissoes = (control?.value ?? []) as string[];

    if (permissoes.includes(permissao)) {
      control?.setValue(permissoes.filter(p => p !== permissao));
    } else {
      control?.setValue([...permissoes, permissao]);
    }
  }

  submit() {
    const formValues = this.formulario.value;

    const perfil: Perfil = new Perfil(
      formValues.id,
      formValues.nome,
      formValues.descricao.toUpperCase(),
      formValues.ativo,
      formValues.permissoes
    );

    if (formValues.id) {
      this.perfilService.alterar(perfil).subscribe(
        response => {
          this.snackBar.open(
            'Perfil atualizado com sucesso! Faça login novamente para aplicar as alterações.',
            'OK',
            { duration: 4000 }
          );
          this.router.navigate(['/perfil/form', response.id]);
        },
        error => {
          this.snackBar.open(error.error.message, 'ERRO', {
            duration: 2000
          });
        }
      );
    } else {
      this.perfilService.salvar(perfil).subscribe(
        response => {
          this.snackBar.open('Perfil salvo com sucesso!', 'Sucesso', {
            duration: 2000
          });
          this.router.navigate(['/perfil/form', response.id]);
        },
        error => {
          this.snackBar.open(error.error.message, 'ERRO', {
            duration: 2000
          });
        }
      );
    }
  }

  carregar(id: number) {
    this.carregando = true;
    this.perfilService.consultarPorId(id).subscribe((response) => {
      this.formulario.controls['id']!.setValue(id);
      this.formulario.controls['nome']!.setValue(response.nome);
      this.formulario.controls['descricao']!.setValue(response.descricao);
      this.formulario.controls['ativo']!.setValue(response.ativo);
      this.formulario.controls['permissoes']!.setValue(response.permissoes);
      this.carregando = false;
    }, () => {
      this.carregando = false;
      this.snackBar.open('Perfil não encontrado.', 'ERRO', { duration: 2500 });
      this.voltarConsulta();
    });
  }

  montarFormulario() {
    this.formulario = this.formBuilder.group({
      id: [''],
      nome: ['', Validators.required],
      descricao: ['', Validators.required],
      permissoes: [[]],
      ativo: [true],
    });
  }

  getPermissoes() {
    this.permissoes = Object.values(Menu).map((menu) => {
      this.nomePermissoes.push(MenuInfo[menu].nome);
      return menu;
    });
  }

  getPermissaoPorNome(nome: string): Menu {
    const entry = Object.entries(MenuInfo).find(
      ([, descricao]) => descricao.nome === nome
    );

    if (!entry) {
      throw new Error(`Menu não encontrado para o nome: ${nome}`);
    }

    return entry[0] as Menu;
  }

  limparFormulario() {
    this.router.navigate(['/perfil/form']);
    this.montarFormulario();
  }

  voltarConsulta() {
    this.router.navigate(['/perfil/consulta']);
  }
}
